import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";


function RepeatedPYQMathTopics() {
  return (
    <>

      <AllSubjectTopics subject="math" type="repeatedpyq" />

    </>
  );
}

export default RepeatedPYQMathTopics;